import React from "react"
import PropTypes from "prop-types"
import FormStep from "components/FormStep"
import { FormLabel, FormGroup } from "react-bootstrap"
import { GridToggle } from "components/GridToggle"
import LimitedToTeamsFormWrapper from "shared/forms/LimitedToTeams/LimitedToTeamsFormWrapper"

import {
    AVAILABLE_TO_EVERYONE,
    READ_LIMITED_TO_TEAMS,
    READ_JUST_ME,
    teamPermissioningHelpText,
} from "shared/imports/sharedConstants"
import hideIfTrue from "imports/hideIfTrue"
import { ContentSwitcher } from "quorumdesign"

import * as S from "app/static/frontend/forms/components/DesktopLimitedToTeamsFormWrapper/style"
import urls from "imports/desktopPaths"

export const DesktopLimitedToTeamsFormWrapperComponent = ({
    canLimitToCreator,
    children,
    enableLimitedToTeamsOptions,
    formLabel,
    handleOnChange,
    isLimitedToTeamsEnabled,
    canPermissionToPartners = false,
    limitToTeamsGridToggleVal,
    shouldHideTeamPermissioningFormComponent,
    shouldParentManageFormStep,
    shouldRenderFormSection,
    shouldRenderNewComponents,
    shouldRenderPartnerToggle,
    step,
    shouldShowAvailableToEveryone,
}) => {
    const renderFormWrapper = () => {
        const filteredLimitedToTeamsOptions = enableLimitedToTeamsOptions.filter((option) => {
            if (option.value === READ_JUST_ME) {
                return canLimitToCreator
            } else if (option.value === READ_LIMITED_TO_TEAMS && isLimitedToTeamsEnabled) {
                return true
            } else if (option.value === AVAILABLE_TO_EVERYONE) {
                return shouldShowAvailableToEveryone
            }

            return false
        })

        return shouldRenderNewComponents ? (
            <S.PermissionsWrapper>
                <S.Description>
                    {teamPermissioningHelpText(canPermissionToPartners, shouldRenderPartnerToggle)}
                    <a href={urls.zdHelpCenterTeamPermissions} target="_blank" rel="noopener noreferrer">
                        here.
                    </a>
                </S.Description>
                <ContentSwitcher
                    dataCy="limited-to-teams-switcher"
                    options={filteredLimitedToTeamsOptions}
                    onChange={handleOnChange}
                    value={limitToTeamsGridToggleVal}
                />
                {limitToTeamsGridToggleVal === READ_LIMITED_TO_TEAMS && children}
            </S.PermissionsWrapper>
        ) : (
            <span id="limitedToTeamsFormWrapper" style={hideIfTrue(shouldHideTeamPermissioningFormComponent)}>
                <div className="form-section-description">
                    {teamPermissioningHelpText(canPermissionToPartners, shouldRenderPartnerToggle)}
                    <a href={urls.zdHelpCenterTeamPermissions} target="_blank" rel="noopener noreferrer">
                        here.
                    </a>
                </div>
                <FormLabel className="control-label">{"Access"}</FormLabel>
                <FormGroup className="form-group">
                    <GridToggle
                        bsColWidth={12 / filteredLimitedToTeamsOptions.length}
                        options={filteredLimitedToTeamsOptions.map((option, idx) => ({ ...option, key: idx }))}
                        onChange={handleOnChange}
                        value={limitToTeamsGridToggleVal}
                    />
                </FormGroup>
                {limitToTeamsGridToggleVal === READ_LIMITED_TO_TEAMS && children}
            </span>
        )
    }

    if (shouldRenderFormSection && shouldParentManageFormStep) {
        return renderFormWrapper()
    } else if (shouldRenderFormSection) {
        // we need color banding to work, and hidden elements with similar tags (regardless of class) confuses it
        return shouldHideTeamPermissioningFormComponent ? (
            <span className="form-wrapper-hide-wrapper" style={{ display: "none" }}>
                <FormStep step={step} label={formLabel} overrideFormStepClass>
                    {renderFormWrapper()}
                </FormStep>
            </span>
        ) : (
            <div className="form-wrapper-hide-wrapper form-step">
                <FormStep step={step} label={formLabel} overrideFormStepClass>
                    {renderFormWrapper()}
                </FormStep>
            </div>
        )
    }

    return null
}

export const DesktopLimitedToTeamsFormWrapper = (props) => (
    <LimitedToTeamsFormWrapper
        LimitedToTeamsFormWrapperComponent={DesktopLimitedToTeamsFormWrapperComponent}
        {...props}
    />
)

DesktopLimitedToTeamsFormWrapper.propTypes = {
    shouldHideTeamPermissioningFormComponent: PropTypes.bool,
    // if the user has the permissioning to limit this object to only themselves
    canLimitToCreator: PropTypes.bool,
    shouldShowAvailableToEveryone: PropTypes.bool,
}

DesktopLimitedToTeamsFormWrapper.defaultProps = {
    canLimitToCreator: false,
    shouldHideTeamPermissioningFormComponent: false,
    shouldShowAvailableToEveryone: true,
}

export default DesktopLimitedToTeamsFormWrapper
